export enum ChannelDetailsQueryParam {
  TEAM = 'team',
  GAME = 'game'
}
